import state from './icfusionendpoint.state'
import mutations from './icfusionendpoint.mutations'
import actions from './icfusionendpoint.actions'

export default {
  state,
  mutations,
  actions
}
